import React from 'react';

interface LiqPageContainerProps {
    children: React.ReactNode;
}

const LiqPageContainer = ({ children }: LiqPageContainerProps) => {
    return (
        <div className="lg:py-32 py-20 mx-auto max-w-[100rem] min-h-[100vh]">
            <div className="grid grid-cols-12">{children}</div>
        </div>
    );
};

export default LiqPageContainer;
